// Права, которые проверяет бэкенд (IDT.CemLife.Realtime.Api/Access/CemLifePermissions.cs
// и модуль доступа). Интерфейс скрывает то, на что у пользователя нет прав; проверка
// всё равно выполняется на сервере.
export const Permissions = {
  WellsRead: "wells.read",
  LogsDelete: "logs.delete",
  CasesRead: "cases.read",
  CasesWrite: "cases.write",
  CalculationsView: "calculations.view",
  CalculationsManage: "calculations.manage",
  SystemInfo: "system.info",
  UsersManage: "users.manage",
  RolesManage: "roles.manage",
} as const;

export type Permission = (typeof Permissions)[keyof typeof Permissions];
